import { create } from "zustand";
const initialState = {
    users: [],
    isLoading: false,
    error: null,
    currentUserRole: null
};
const useOrganizationStoreBase = create((set)=>({
        ...initialState,
        actions: {
            setUsers: (users)=>set({
                    users
                }),
            setLoading: (isLoading)=>set({
                    isLoading
                }),
            setError: (error)=>set({
                    error
                }),
            setCurrentUserRole: (currentUserRole)=>set({
                    currentUserRole
                }),
            addUser: (user)=>set((state)=>({
                        users: [
                            ...state.users,
                            user
                        ]
                    })),
            removeUser: (userId)=>set((state)=>({
                        users: state.users.filter((user)=>user.UserId !== userId)
                    })),
            updateUser: (userId, updates)=>set((state)=>({
                        users: state.users.map((user)=>user.UserId === userId ? {
                                ...user,
                                ...updates
                            } : user)
                    })),
            reset: ()=>set(initialState)
        }
    }));
export const useOrganizationStore = ()=>useOrganizationStoreBase((state)=>state);
export const useOrganizationActions = ()=>useOrganizationStoreBase((state)=>state.actions);
// Export store directly for access outside React components
export const organizationStore = useOrganizationStoreBase;
